$(".case-study-category-selector").on('click', function () {
    var target = $(this).data('target');

    $('.case-study-category-selector').not($(this)).removeClass('is-selected');
    $(this).addClass('is-selected');

    $('.case-study-category-container').not(target).addClass('is-hiding');

    setTimeout(function () {
        $('.case-study-category-container').not(target).removeClass('is-active-case-study');
        $(target).addClass('is-active-case-study');
    }, 300);

    setTimeout(function () {
        $(target).removeClass('is-hiding');
    }, 600);

});
